//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create interaction -------------
export const createOnewayBingo = (returnedPayload) => ({ type: ActionTypes.oneway_bingo.create_oneway_bingo, payload: returnedPayload });

export const updateOnewayBingo = (returnedPayload) => ({ type: ActionTypes.oneway_bingo.update_oneway_bingo, payload: returnedPayload });

export const deleteOnewayBingo = (returnedPayload) => ({ type: ActionTypes.oneway_bingo.delete_oneway_bingo, payload: returnedPayload });

export const listOnewayBingo = (returnedPayload) => ({ type: ActionTypes.oneway_bingo.list_oneway_bingo, payload: returnedPayload });

export const listTeachersBingo = (returnedPayload) => ({ type: ActionTypes.oneway_bingo.list_teachers_bingo, payload: returnedPayload });

export const getLearningModuleCount = (returnedPayload) => ({ type: ActionTypes.oneway_bingo.get_learning_module_count, payload: returnedPayload });